<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single page-content">
        <div class="container-max">
          <div class="d-flex row position-relative justify-content-between">
            <div class="col-12 d-md-none d-sm-block">
              <div class="h2 title spc-sm-bt">
                {{ currentVariation | itemName }}
              </div>
              <div class="item-artnr-strs spc-mdm-bt">
                <div>
                  <span class="articlenumber small">
                      {{ $translate("Ceres::Template.singleItemNumber") }}
                    <span>{{ currentVariation.variation.id }}</span>
                  </span>
                </div>
                <a class="trust-star-row" href="#feedback-section">
                  <div class="trust-star" v-for="n in 5">
                    <div v-if="currentVariation.item.feedbackDecimal >= n" class="trust-star-form trust-star-fill">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
                        <path fill="none" d="M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"></path>
                      </svg>
                    </div>
                    <template v-else>
                      <div class="trust-star-form">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
                          <path fill="none" d="M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"></path>
                        </svg>
                      </div>
                      <div v-if="(currentVariation.item.feedbackDecimal - n +1) > 0" class="trust-star-form trust-star-last" :style="'clip-path:inset(0px '+ (100-((currentVariation.item.feedbackDecimal - n +1) * 100)) +'% 0px 0px)'">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
                          <path fill="none" d="M6.826 10.743l-3.28 1.724a.5.5 0 0 1-.725-.528l.627-3.65a.5.5 0 0 0-.144-.443L.65 5.26a.5.5 0 0 1 .277-.853l3.666-.533a.5.5 0 0 0 .377-.273L6.61.279a.5.5 0 0 1 .896 0L9.147 3.6a.5.5 0 0 0 .376.273l3.666.533a.5.5 0 0 1 .277.853l-2.653 2.586a.5.5 0 0 0-.144.442l.627 3.651a.5.5 0 0 1-.726.528l-3.279-1.724a.5.5 0 0 0-.465 0z"></path>
                        </svg>
                      </div>
                    </template>
                  </div>
                </a>
              </div>
            </div>

            <div id="itemImageSection" class="col-12 col-md-7 col-xx-8 mx-wdth-lrg ml-auto mr-auto pl-0">
              <div v-stick-in-parent>
                <slot name="image-carousel"></slot>

              </div>
            </div>
            <div class="col-12 col-md-5 col-xx-4 pl-md-0 mt-spec">
              <div v-stick-in-parent>
                <div class="d-md-block d-none">
                  <h1 class="h2 title spc-sm-bt" data-testing="item-name">
                    {{ currentVariation | itemName }}
                  </h1>
                  <div class="item-artnr-strs spc-mdm-bt">
                    <div>
                      <span class="articlenumber small">
                          {{ $translate("Ceres::Template.singleItemNumber") }}
                        <span>{{ currentVariation.variation.id }}</span>
                      </span>
                    </div>
                    <slot name="star-rating-wrapper"></slot>
                  </div>
                </div>
                <template v-if="$store.getters.currentItemVariation.variationProperties && $store.getters.currentItemVariation.variationProperties.length > 0">
                  <template v-for="(variationPropertyGroups, index) in $store.getters.currentItemVariation.variationProperties">
                    <div v-if="variationPropertyGroups.id == 16" class="d-lg-none d-md-block d-none showTechnicalData">
                      <span style="margin-rigth:4.5px">{{ $translate("Ceres::Template.singleItemDescription") }}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6.069" viewBox="0 0 10 6.069">
                        <path id="chevron-right-solid" d="M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z" transform="translate(47.657 -27.495) rotate(90)" fill="#464646"/>
                      </svg>
                    </div>
                    <ul id="singleItemTechnicalData" v-if="variationPropertyGroups.id == 16" class="TechnicalDataArea">
                      <template v-for="(variationProperty, index) in variationPropertyGroups.properties">
                        <li v-html="variationProperty.values.value" v-if="variationProperty.id == 427 || variationProperty.id == 428 || variationProperty.id == 429 || variationProperty.id == 430 || variationProperty.id == 431"></li>
                      </template>
                    </ul>
                  </template>
                </template>
                <!-- END TECHNICAL DETAILS -->
                <div class="col-12 p-0">
                  <a :href="'#description-section'" class="gotoDescription d-lg-block d-md-none d-sm-block">
                    <span style="margin-rigth:4.5px">{{ $translate("Ceres::Template.singleItemDescription") }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6.069" viewBox="0 0 10 6.069">
                      <path id="chevron-right-solid" d="M33.4,43.046l-4.45,4.45a.55.55,0,0,1-.777,0l-.519-.519a.55.55,0,0,1,0-.776l3.527-3.544-3.527-3.544a.55.55,0,0,1,0-.776l.519-.519a.55.55,0,0,1,.777,0l4.45,4.45A.55.55,0,0,1,33.4,43.046Z" transform="translate(47.657 -27.495) rotate(90)" fill="#464646"/>
                    </svg>
                  </a>
                </div>
                <!-- Eigenschaft EEK -->
                <div class="etc-eek d-flex spc-mdm">
                  <div class="etc-eek-label">
                    <a
                        v-if="property194 && property194.values && property194.values.value"
                        :href="property194.values.value"
                        data-lightbox="single-item-image23"
                    >
                      <lazy-img
                          v-if="property172 && property172.values && property172.values.description"
                          :image-url="property172.values.description"
                          picture-class="lazyEek"
                      />
                    </a>
                    <lazy-img
                        v-else-if="property172 && property172.values && property172.values.description"
                        :image-url="property172.values.description"
                        picture-class="lazyEek"
                    />
                  </div>
                  <pdf-viewer
                      v-if="property209 && property209.values && property209.values.value"
                      :pdfUrl="property209.values.value"
                  />

                </div>
                <div :class="'spc-mdm'" v-if="attributes.length">
                  <variation-select></variation-select>
                </div>
                <item-price :show-cross-price="isRecommendedPriceActive"></item-price>
                <slot name="after-price"></slot>
                <div class="col-12 d-flex p-0 mt-1 space-between h-lg-50">
                  <div @click="showModal('shipping')" class="openShippingCostsWrapper btn col-4 bg-lightgrey flex-auto d-flex justify-content-center align-items-center ModalInformationCard">
                    <span v-html="$translate('ETCeresCoconut::Template.singleItemShippingCostsInformation')"></span>
                  </div>
                  <div @click.prevent="$root.$emit('open-newsletter-modal')" class="btn openNewsletterWrapper col-4 bg-lightgrey mr-1 ml-1 flex-auto d-flex justify-content-center align-items-center ModalInformationCard"><span v-html="$translate('ETCeresCoconut::Template.singleItemNewsletterInformation')"></span></div>
                  <div @click="showModal('payment')" id="openPaymentsWrapper" class="btn col-4 bg-lightgrey flex-auto d-flex justify-content-center align-items-center ModalInformationCard"><span v-html="$translate('ETCeresCoconut::Template.singleItemPaymentsInformation')"></span></div>
                </div>
                <div class="spc-mdm availability">
                  <div class="half-circle p-0 m-0" :class="'availability-' + currentVariation.variation.availability.id">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
                      <path id="circle-check-solid" d="M7.5,15A7.5,7.5,0,1,0,0,7.5,7.5,7.5,0,0,0,7.5,15Zm3.311-8.877-3.75,3.75a.7.7,0,0,1-.993,0L4.192,8A.7.7,0,0,1,5.186,7L6.563,8.382,9.814,5.127a.7.7,0,1,1,.993.993Z" fill="#fff"/>
                    </svg>
                  </div>
                  <div class="availability-name" :class="'availability-' + currentVariation.variation.availability.id">
                    <template v-if="currentVariation.variation.availability.id == 1">{{ $translate("ETCeresCoconut::Template.singleItemAvailability1") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 2">{{ $translate("ETCeresCoconut::Template.singleItemAvailability2") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 3">{{ $translate("ETCeresCoconut::Template.singleItemAvailability3") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 4">{{ $translate("ETCeresCoconut::Template.singleItemAvailability4") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 5">{{ $translate("ETCeresCoconut::Template.singleItemAvailability5") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 6">{{ $translate("ETCeresCoconut::Template.singleItemAvailability6") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 7">{{ $translate("ETCeresCoconut::Template.singleItemAvailability7") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 8">{{ $translate("ETCeresCoconut::Template.singleItemAvailability8") }}</template>
                    <template v-else-if="currentVariation.variation.availability.id == 9">{{ $translate("ETCeresCoconut::Template.singleItemAvailability9") }}</template>
                    <template v-else>{{ $translate("ETCeresCoconut::Template.singleItemAvailability10") }}</template>
                  </div>
                </div>
                <div class="spc-mdm">
                  <div class="w-100">
                    <slot name="before-add-to-basket"></slot>
                  </div>
                  <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                  </div>
                  <div v-else class="col-12 col-sm-12 col-md-12 col-lg-12 my-3 p-0 d-flex" style="align-items:baseline;">
                    <add-to-wish-list :variation-id="currentVariation.variation.id" class="singleItemAddToWishlist"></add-to-wish-list>
                    <add-to-basket
                        class="w-100 btn-width-unset"
                        :variation-id="currentVariation.variation.id"
                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                        :use-large-scale="false"
                        :show-quantity="true"
                        :item-url="currentVariation | itemURL"
                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                        :has-price="currentVariation | hasItemDefaultPrice"
                    >
                    </add-to-basket>
                  </div>
                  <div class="w-100">
                    <slot name="after-add-to-basket"></slot>
                  </div>
                </div>
                <slot name="trust-badge"></slot>
                <hr style="margin-top: 30px;margin-bottom: 20px;" />
                <div class="spc-lrg-tp d-flex row artikel-entsorgungshinweis font-12">
                  <div class="d-flex geraeteruecknahme">
                    <template v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                      <order-property-list></order-property-list>
                    </template>
                  </div>
                  <div class="d-flex artikel-entsorgungshinweis-link">
                    <a class="openEntsorgungshinweisWrapper btn font-12 p-0" @click="showModal('disposal')">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15.335" height="15" viewBox="0 0 15.335 15">
                        <path id="recycle-solid" d="M5.4,7.293a.718.718,0,0,1-1.081.77l-.728-.455L2.07,10.047a.959.959,0,0,0,.813,1.467h.959a.959.959,0,0,1,0,1.917H2.886a2.876,2.876,0,0,1-2.44-4.4L1.969,6.6l-.73-.458a.72.72,0,0,1,.22-1.312L4.2,4.192a.485.485,0,0,1,.578.361ZM8.486,2.377,9.721,4.358,9,4.81a.719.719,0,0,0,.218,1.311l2.738.633a.479.479,0,0,0,.575-.36l.63-2.739a.719.719,0,0,0-1.08-.772l-.73.455L10.112,1.364a2.876,2.876,0,0,0-4.876,0l-.222.354A.958.958,0,0,0,6.638,2.733l.223-.356A.959.959,0,0,1,8.486,2.377ZM14.9,9.036l-.509-.816a.957.957,0,1,0-1.624,1.014l.509.813a.959.959,0,0,1-.813,1.468H9.59v-.861a.719.719,0,0,0-1.227-.508l-1.989,1.99a.481.481,0,0,0,0,.678L8.364,14.8a.719.719,0,0,0,1.227-.509v-.859h2.871A2.875,2.875,0,0,0,14.9,9.036Z" transform="translate(-0.007 -0.012)"/>
                      </svg>
                      <span>{{ $translate("ETCeresCoconut::Template.footerInformationSectionEntsorgungshinweiseText") }}</span>
                    </a>
                  </div>
                </div>
                <slot name="additional-content-after-add-to-basket"></slot>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-section">
          <div class="container-max max-1330">
            <!-- ITEM DESCRIPTION -->
            <div class="my-3">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" v-if="isDescriptionTabActive">
                  <a
                      id="description-section"
                      class="nav-link active"
                      data-toggle="tab"
                      :href="'#details-' + currentVariation.variation.id"
                      role="tab">{{ $translate("Ceres::Template.singleItemDescription") }}</a>
                </li>
                <li class="nav-item" v-if="isEuResponsibleTabShown && showResponsible">
                  <a
                      class="nav-link"
                      data-toggle="tab"
                      href="#eu-responsible"
                      role="tab">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</a>
                </li>
                <li class="nav-item" v-if="isManufacturerTabShown && showManufacturer">
                  <a class="nav-link" data-toggle="tab" href="#manufacturer" role="tab">{{ $translate("Ceres::Template.singleItemManufacturer") }}</a>
                </li>
                <slot name="add-detail-tabs"></slot>
              </ul>

              <div class="tab-content overflow-hidden">
                <div class="tab-pane active overflow-auto" :id="'details-' + currentVariation.variation.id" role="tabpanel" v-if="isDescriptionTabActive">
                  <div class="my-4" v-html="currentVariation.texts.description">
                  </div>
                </div>
                <div class="tab-pane overflow-auto" id="eu-responsible" role="tabpanel" v-if="isEuResponsibleTabShown && showResponsible">
                  <div class="my-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                      <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                      <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                       {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                      </span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                    </div>
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                    </div>
                  </div>
                </div>
                <div class="tab-pane overflow-auto" id="manufacturer" role="tabpanel" v-if="isManufacturerTabShown">
                  <div class="my-4">
                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.name }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.legalName }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.street }}</span>
                      <span>{{ currentVariation.item.manufacturer.houseNo }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.postcode }}</span>
                      <span>{{ currentVariation.item.manufacturer.town }}</span>
                      <span v-if="currentVariation.item.manufacturer.countryObject">
                                      {{ currentVariation.item.manufacturer.countryObject.name }}
                                    </span>

                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.email }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.url }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.phoneNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.faxNumber }}</span>
                    </div>

                    <div class="p-0">
                      <span>{{ currentVariation.item.manufacturer.contactUrl }}</span>
                    </div>
                  </div>
                </div>
                <slot name="add-detail-tabs-content"></slot>
              </div>
            </div>
            <!-- ./ITEM DESCRIPTION -->
          </div>
        </div>
        <slot name="cross-selling-similar"></slot>
        <slot name="cross-selling-accessory"></slot>

        <lazy-content-modal
            :visible="modalType === 'shipping'"
            :category-id="shippingCategoryId"
            :title="$translate('ETCeresCoconut::Template.footerInformationSectionVersandText')"
            @close="modalType = null"
        />

        <lazy-content-modal
            :visible="modalType === 'payment'"
            :category-id="paymentCategoryId"
            :title="$translate('ETCeresCoconut::Template.footerInformationSectionZahlungText')"
            @close="modalType = null"
        />

        <lazy-content-modal
            :visible="modalType === 'disposal'"
            :category-id="disposalCategoryId"
            :title="$translate('ETCeresCoconut::Template.footerInformationSectionEntsorgungshinweiseText')"
            @close="modalType = null"
        />


        <div class="container-max max-1330" id="feedback-section">
          <slot name="default-dropzone"></slot>
        </div>
        <slot name="feedback-container"></slot>
        <slot name="item-list-container"></slot>
      </div>
    </slot>
  </div>
</template>

<script>
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";
import StarRating from "../common/StarRating.vue";
import LazyContentModal from '../common/LazyContentModal.vue';

export default {

  name: "single-item",
  components: {
    StarRating, // Registriere die Komponente
    LazyContentModal
  },
  data() {
    return {
      modalType: null
    };
  },
  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false
    },
    showNetPrices: {
      type: Boolean,
      default: false
    },
    isWishListEnabled: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: Number,
      required: true
    },
    afterKey: Object,
    showResponsible: {
      type: Boolean,
      default: false
    },
    showManufacturer: {
      type: Boolean,
      default: false
    },
    shippingCategoryId: {
      type: Number,
      default: 0
    },
    paymentCategoryId: {
      type: Number,
      default: 0
    },
    disposalCategoryId: {
      type: Number,
      default: 0
    }
  },

  jsonDataFields: [
    "itemData",
    "attributesData",
    "variations"
  ],

  provide()
  {
    return {
      itemId: this.$props.itemId
    }
  },

  computed:
      {
        property194() {
          return this.findPropertyById(194);
        },
        property172() {
          return this.findPropertyById(172);
        },
        property209() {
          return this.findPropertyById(209);
        },

        itemConfig()
        {
          return App.config.item.itemData;
        },

        isDescriptionTabActive()
        {
          return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
              && !!this.currentVariation.texts.description.length;
        },

        isManufacturerTabShown()
        {
          return (this.currentVariation.item.manufacturer.url !== "") ||
              (this.currentVariation.item.manufacturer.street !== "") ||
              (this.currentVariation.item.manufacturer.houseNo !== "") ||
              (this.currentVariation.item.manufacturer.postcode !== "") ||
              (this.currentVariation.item.manufacturer.town !== "") ||
              (this.currentVariation.item.manufacturer.countryId !== 0) ||
              (this.currentVariation.item.manufacturer.phoneNumber !== "") ||
              (this.currentVariation.item.manufacturer.faxNumber !== "") ||
              (this.currentVariation.item.manufacturer.email !== "") ||
              (this.currentVariation.item.manufacturer.legalName !== "") ||
              (this.currentVariation.item.manufacturer.contactUrl !== "") ||
              (this.currentVariation.item.manufacturer.name !== "") ||
              (this.currentVariation.item.manufacturer.externalName !== "");
        },
        isEuResponsibleTabShown()
        {
          return (this.currentVariation.item.manufacturer.responsibleEmail !== "") ||
              (this.currentVariation.item.manufacturer.responsibleHouseNo !== "") ||
              (this.currentVariation.item.manufacturer.responsibleName !== "") ||
              (this.currentVariation.item.manufacturer.responsiblePhoneNo !== "") ||
              (this.currentVariation.item.manufacturer.responsiblePostCode !== "") ||
              (this.currentVariation.item.manufacturer.responsibleStreet !== "") ||
              (this.currentVariation.item.manufacturer.responsibleTown !== "") ||
              (this.currentVariation.item.manufacturer.responsibleContactUrl !== "") ||
              (this.currentVariation.item.manufacturer.responsibleCountry !== 0);
        },

        isRecommendedPriceActive()
        {
          return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
        },

        isShortDescriptionActive()
        {
          return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
        },

        hasShippingCostsCategoryId()
        {
          return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive()
        {
          return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
              && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties()
        {
          return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties()
        {
          return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
          return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
          return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        },

        isItemSet() {
          return this.$store.state.items.isItemSet;
        }
      },

  created()
  {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted()
  {
    this.$nextTick(() =>
    {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId:             this.itemId,
        attributes:         this.attributesData,
        variations:         this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey:           this.afterKey
      });

      if (this.isItemSet)
      {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    }
    )
    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods:
      {
        getDataField(field)
        {
          return get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter)
        {
          if (!isNullOrUndefined(this.$options.filters[filter]))
          {
            return this.$options.filters[filter](this.getDataField(field));
          }

          return this.getDataField(field);
        },
        showModal(type) {
          this.modalType = type;
        },
        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
          nodes.forEach(component => {
            if (component.$options.name === "lazy-hydrate")
            {
              component.hydrate();
            }
            else if (component.$children.length)
            {
              this.hydrateChildren(component.$children);
            }
          })
        },
        findPropertyById(id) {
          for (const group of this.$store.getters.currentItemVariation.variationProperties) {
            for (const prop of group.properties) {
              if (prop.id === id) return prop;
            }
          }
          return null;
        }
      }
}
</script>
